import React from "react";
import Image from "react-bootstrap/Image";

import "./PrimaryButtonWithBonusTag.scss";
import ImageShimmer from "../../../images/shimmer.svg";
import ImageGift from "../../../images/gift.svg";
import PrimaryActionButton, {
  IPrimaryActionButtonProps,
} from "../../Buttons/PrimaryActionButton/PrimaryActionButton";

export default function PrimaryButtonWithBonusTag({
  showBonusTag = true,
  ...props
}: IPrimaryActionButtonProps & { showBonusTag?: boolean }) {
  return (
    <div className="position-relative">
      {showBonusTag && (
        <div className="text-white welcome-bonus-text-container animated-background">
          <Image src={ImageShimmer} alt="shimmer" className="shimmer" />
          <span className="welcome-bonus-text">
            <Image src={ImageGift} height={12} width={12} /> +100% Bonus
          </span>
        </div>
      )}
      <PrimaryActionButton size="lg" {...props} />
    </div>
  );
}
